const API_KEY = '&APIKey=65d5a3e79fcd603b3845f0dc7c2437f0';

const ODDS_API_WEB = 'https://www.odds.com.au/api/web';
const PUNTERS_API_WEB_PUBLIC = 'https://www.punters.com.au/api/web/public';
const PUNT_API = 'https://puntapi.com';
const RACENET_API = 'https://api.racenet.com.au';

const API_END_POINTS = {
  MAIN: `${ODDS_API_WEB}/Event/getEventHeader/?eventId=648428&allowGet=true${API_KEY}`,
  MENU_LIST: `${ODDS_API_WEB}/Menu/getOddsNavigationCacheable/?itemLimit=5&allowGet=true${API_KEY}`,
  SIDE_NAV_LIST: `${ODDS_API_WEB}/public/SiteNavigation/getSiteMenuCacheable/?allowGet=true${API_KEY}`,
  SITE_MAP_MAIN: `${ODDS_API_WEB}/Sitemap/getMainSitemapSlugs/?${API_KEY}`,
  SITE_MAP_MEETINGS: `${ODDS_API_WEB}/Sitemap/getRaceMeetingSlugs/?${API_KEY}`,
  SITE_MAP_SPORT_EVENTS: `${ODDS_API_WEB}/Sitemap/getSportEventSlugs/?${API_KEY}`,
  BOOKIE_STRIP: `${ODDS_API_WEB}/Betting/getMainTile/?allowGet=true${API_KEY}`,
  NEWS_ARTICLE_CONTENT: `${PUNT_API}/news/web-odds/article/my-new-article-2017-11-30`,
  NEXT_TO_JUMP: {
    MULTIPLE_SPORTS: `${PUNTERS_API_WEB_PUBLIC}/NextToJump/getMultipleSportsCacheable/?filter=racing&allowGet=true${API_KEY}`,
    RELATED_EVENTS: `${PUNTERS_API_WEB_PUBLIC}/NextToJump/getRelatedToEvent/?eventId=666254&limit=8&allowGet=true${API_KEY}`,
  },
  NEXT_TO_PLAY: {
    MULTIPLE_SPORTS: `${PUNTERS_API_WEB_PUBLIC}/NextToJump/getMultipleSportsCacheable/?filter=sport&allowGet=true${API_KEY}`,
    RELATED_EVENTS: `${PUNTERS_API_WEB_PUBLIC}/NextToJump/getRelatedToEventCacheable/?allowGet=true${API_KEY}`,
  },
  TIPS: `${ODDS_API_WEB}/Featured/getUpcomingExpertTipsCacheable/?allowGet=true${API_KEY}`,
  ODDS_COMPARISON_TABLE: {
    BY_MEETING_SLUG: `${ODDS_API_WEB}/Meetings/getEventOddsComparisonsCacheable/?allowGet=true${API_KEY}`,
    BY_EVENT_ID: `${PUNTERS_API_WEB_PUBLIC}/Odds/getOddsComparisonCacheable/?allowGet=true${API_KEY}`,
  },
  RELATED_NEWS: `${PUNT_API}/news/web-odds/articles`,
  UPCOMING_MEETINGS: {
    BY_SPORT: `${ODDS_API_WEB}/Meetings/getUpcomingBySportCacheable/?allowGet=true${API_KEY}`,
    BY_REGION: `${ODDS_API_WEB}/Meetings/getUpcomingByRegionCacheable/?allowGet=true${API_KEY}`,
  },
  MEETING: {
    BY_SLUG: `${ODDS_API_WEB}/Meetings/getMeetingBySlugCacheable/?allowGet=true${API_KEY}`,
  },
  VERDICT: `${ODDS_API_WEB}/Verdict/getForMeetingCacheable/?allowGet=true${API_KEY}`,
  BLOB: `${ODDS_API_WEB}/Blobs/getBlobByPathCacheable/?allowGet=true${API_KEY}`,
  MARKET_SPECIALS: `${ODDS_API_WEB}/Promotions/getUpcomingGroupedByMeetingCacheable/?allowGet=true${API_KEY}`,
  ODDS: {
    EVENT_BASE: `${PUNT_API}/odds/au/event/`,
    EVENT: ({ eventId, selectionId }) =>
      `${PUNT_API}/odds/event/${eventId}/selection/${selectionId}/?derived=best&betTypes=fixed-win`,
    EVENTS: `${PUNT_API}/odds/events/`,
    BEST: `${PUNT_API}/odds/events/?betTypes=fixed-win&derived=best&events=`,
  },
  CONTACT_US: `${PUNTERS_API_WEB_PUBLIC}/Contact/sendUserFeedbackToService/?allowGet=true${API_KEY}`,
  LIVE_SCORES: `${PUNT_API}/livescores/getScore/`,
  PRODUCT_INTEGRATION: `${ODDS_API_WEB}/Odds/getMeetingHeader/?allowGet=true${API_KEY}`,
  UP_COMING_RACES: `${ODDS_API_WEB}/public/Racing/getUpcomingRacesByMeetingSlugCacheable/?allowGet=true${API_KEY}`,
  EXPERT_TIPS: `${PUNTERS_API_WEB_PUBLIC}/ExpertTips/getExpertTipsCacheable/?allowGet=true${API_KEY}`,
  FORM_FINDER: `${PUNT_API}/stats/sport/horse-racing/filter/upcoming`,
  FORM_FINDER_PRESET: {
    PRESET({ env }) {
      if (env === 'dev') {
        return {
          ENDPOINT_FILTERS: `http://localhost:8010/proxy/stats/filters/`,
          APIKEY: `lMJOLJG9if5OvuLor2H6W8haYC6uYCJY6deX851L`,
        };
      }
      if (env === 'prod') {
        return {
          ENDPOINT_FILTERS: `https://www.punters.com.au/stats/filters/`,
          APIKEY: `lMJOLJG9if5OvuLor2H6W8haYC6uYCJY6deX851L`,
        };
      }
    },
  },
  FORM_FINDER_FIELDS: `${PUNT_API}/stats/filter-fields/form-finder-3`,
  GEAR_CHANGES: `${PUNTERS_API_WEB_PUBLIC}/Meetings/getUpcomingGearChangesCacheable/?allowGet=true${API_KEY}`,
  BETTING_PROMOTIONS: `${PUNTERS_API_WEB_PUBLIC}/Promotions/getBettingPromotionByEventId/?allowGet=true${API_KEY}`,
  BETTING_PROMOTIONS_LIST: `${PUNTERS_API_WEB_PUBLIC}/Promotions/getUpcomingBettingPromotionsCacheable/?allowGet=true${API_KEY}`,
  VIDEO: `${PUNT_API}/video/video/`,
  VIDEO_PLAYLIST: `${PUNT_API}/video/playlist/`,
  MARKET_MOVERS: `${PUNT_API}/market-movement/movers`,
  LAST_FIVE_MATCHES: {
    REGULAR_TYPE: sportCategory => `${PUNT_API}/stats/sport/${sportCategory}/summary?range=last-5-games`,
    HEAD_TO_HEAD: sportCategory =>
      `${PUNT_API}/stats/sport/${sportCategory}/summary?range=last-5-games&type=head-to-head`,
  },
  STANDINGS: `${PUNT_API}/stats/sport/basketball/ladder`,
  BOOKMAKERS_LIST: `${PUNTERS_API_WEB_PUBLIC}/Bookmakers/getForOddsRegion/?oddsRegion=AU&APIKey=3aUaoKA4UjnY7B8o4QvIC9ltij5ovWTN`,
  BOOKMAKERS_FOR_STACKER: `${PUNTERS_API_WEB_PUBLIC}/Agency/getGeoPromotions/?${API_KEY}`,
  FEATURE_RIBBON: `${ODDS_API_WEB}/public/Meetings/getUpcomingFeatured/?${API_KEY}`,
  HARNESS: {
    MEETING: `${PUNT_API}/racing/harness/meetings/`,
    EVENTS: `${PUNT_API}/racing/harness/events`,
    BY_MEETINGS_DATE: `${PUNT_API}/racing/harness/meetings`,
    STATS: `${PUNT_API}/racing/harness/stats/selections`,
  },
  INJURY_LIST: `${PUNT_API}/stats/injuries`,
  STATS_PANEL: ({ leagueCategory, teamIds }) => `${PUNT_API}/stats/sport/${leagueCategory}/summary?teams=${teamIds}`,
  LINEUP: {
    NRL: eventId => `${PUNT_API}/sport/punters/rugby-league/nrl/${eventId}/lineups`,
    AFL: eventId => `${PUNT_API}/sport/punters/australian-rules/afl/${eventId}/lineups`,
  },
  MATCH_STATS: ({ leagueCategory, teamId, rangeType, range }) =>
    `${PUNT_API}/stats/sport/${leagueCategory}/summary?teams=${teamId}&rangeType=${rangeType}&range=${range}`,
  PREDICTOR: {
    DATA: `${PUNTERS_API_WEB_PUBLIC}/Predictor/getEventPredictorCacheable/?${API_KEY}`,
    META: `${PUNTERS_API_WEB_PUBLIC}/FormGuide/getPredictorHorsesCacheable/?${API_KEY}`,
    GET_PRESET: `${PUNTERS_API_WEB_PUBLIC}/Predictor/getPredictorSettings/`,
    PRESET({ env }) {
      let DOMAIN_URL;
      if (env === 'prod') {
        DOMAIN_URL = 'https://www.punters.com.au/api/web/public/Predictor';
      }

      if (env === 'dev') {
        DOMAIN_URL = 'http://punters.com.au.localhost.vagrant/api/web/public/Predictor';
      }

      if (env === 'staging') {
        DOMAIN_URL = 'https://staging.punters.com.au/api/web/public/Predictor';
      }

      return {
        GET_DATA: `${DOMAIN_URL}/getPredictorSettings/?${API_KEY}`,
        DELETE_DATA: `${DOMAIN_URL}/deletePredictorSetting/?${API_KEY}`,
        UPDATE_DATA: `${DOMAIN_URL}/updatePredictorSetting/?${API_KEY}`,
        SAVE_DATA: `${DOMAIN_URL}/savePredictorSetting/?${API_KEY}`,
      };
    },
  },
  RACING_CALENDAR_EVENT: `${PUNTERS_API_WEB_PUBLIC}/RacingCalendar/getRacingCalendarByEventCacheable/?${API_KEY}`,
  RACING: {
    EVENT: `${PUNTERS_API_WEB_PUBLIC}/FormGuide/getEventSelections/?${API_KEY}`,
  },
  MEETING_INDEX: meetingId => {
    const MEETING_INDEX_API = `${RACENET_API}/api/v1/horse/formguide/meeting`;

    return {
      JOCKEYS: `${MEETING_INDEX_API}/${meetingId}/info/jockeys`,
      TRAINERS: `${MEETING_INDEX_API}/${meetingId}/info/trainers`,
      GEAR_CHANGES: `${MEETING_INDEX_API}/${meetingId}/info/gearChanges`,
    };
  },
  USER_AUTHENTICATION: `${RACENET_API}/connect/token`,
  SHORTLIST: runnerId => {
    const SHORTLIST_API = `${RACENET_API}/api/v2/horse/shortlist/runners`;

    return {
      GET_ALL: SHORTLIST_API,
      UPCOMING: `${SHORTLIST_API}/upcoming`,
      RESULTED: `${SHORTLIST_API}/resulted`,
      ADD_TO_SHORTLIST: SHORTLIST_API,
      UPDATE_COMMENTS: `${SHORTLIST_API}/${runnerId}`,
      DELETE_RUNNER: `${SHORTLIST_API}/${runnerId}`,
    };
  },
};

export default API_END_POINTS;
